export default __webpack_public_path__ + "static/media/swimming.2dc25375.svg";